import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Stack,
} from "@mui/material";

interface Link {
  title: string;
  href: string;
  target: "_self" | "_blank";
}

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (link: Link) => void;
  initialValue?: Link;
}

const LinkDialog = ({ open, onClose, onSave, initialValue }: Props) => {
  const [title, setTitle] = useState("");
  const [href, setHref] = useState("");
  const [openInNewTab, setOpenInNewTab] = useState(false);

  useEffect(() => {
    if (initialValue) {
      setTitle(initialValue.title || "");
      setHref(initialValue.href || "");
      setOpenInNewTab(initialValue.target === "_blank");
    } else {
      setTitle("");
      setHref("https://");
      setOpenInNewTab(false);
    }
  }, [initialValue, open]);

  const handleSave = () => {
    onSave({
      title,
      href,
      target: openInNewTab ? "_blank" : "_self",
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{initialValue ? "Editar Enlace" : "Agregar Enlace"}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            fullWidth
            label="Título"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
          <TextField
            fullWidth
            label="Enlace (URL)"
            value={href}
            onChange={(e) => setHref(e.target.value)}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={openInNewTab}
                onChange={(e) => setOpenInNewTab(e.target.checked)}
              />
            }
            label="Abrir en nueva pestaña"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary" disabled={!title || !href}>
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LinkDialog;
